/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CredentialIssuanceStateResponse
 */
export interface CredentialIssuanceStateResponse {
    /**
     * State of Cred issue state machine
     * @type {string}
     * @memberof CredentialIssuanceStateResponse
     * @deprecated
     */
    credIssueState?: CredentialIssuanceStateResponseCredIssueStateEnum;
    /**
     * State of state machine
     * @type {string}
     * @memberof CredentialIssuanceStateResponse
     */
    state?: CredentialIssuanceStateResponseStateEnum;
    /**
     * State machine ID related to the current workflow. They usually have one-to-one relationships
     * @type {string}
     * @memberof CredentialIssuanceStateResponse
     */
    stateMachineId?: string;
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof CredentialIssuanceStateResponse
     */
    workflowInstanceId?: string;
    /**
     * User id of person who requested the workflow or the operation
     * @type {string}
     * @memberof CredentialIssuanceStateResponse
     */
    requesterId?: string;
    /**
     * Organization Id for whose benefit the workflow is performed or the user works
     * @type {string}
     * @memberof CredentialIssuanceStateResponse
     */
    orgId?: string;
    /**
     * SAID of the bronze id schema
     * @type {string}
     * @memberof CredentialIssuanceStateResponse
     */
    schemaId?: string;
    /**
     * AID prefix of the Issuee
     * @type {string}
     * @memberof CredentialIssuanceStateResponse
     */
    recipient?: string;
    /**
     * JSON object of source
     * @type {object}
     * @memberof CredentialIssuanceStateResponse
     */
    data?: object;
    /**
     * Name of AID of credentials Issuer
     * @type {string}
     * @memberof CredentialIssuanceStateResponse
     */
    issuerName?: string;
    /**
     * OOBI for the issuing credentials
     * @type {string}
     * @memberof CredentialIssuanceStateResponse
     */
    oobi?: string;
    /**
     * True if the recipient is some automation. False if recipient is human. Those 2 cases require different additional parameters
     * @type {boolean}
     * @memberof CredentialIssuanceStateResponse
     */
    isRecipientAutomation?: boolean;
    /**
     * Parameters that are missed in configuration. They prevent to move forward
     * @type {Array<string>}
     * @memberof CredentialIssuanceStateResponse
     */
    missedParams?: Array<string>;
}


/**
 * @export
 */
export const CredentialIssuanceStateResponseCredIssueStateEnum = {
    Configuring: 'CONFIGURING',
    OobiResolving: 'OOBI_RESOLVING',
    Issuing: 'ISSUING',
    Admitting: 'ADMITTING',
    RequiresIssueRetry: 'REQUIRES_ISSUE_RETRY',
    RequiresAdmitRetry: 'REQUIRES_ADMIT_RETRY',
    Failed: 'FAILED',
    Success: 'SUCCESS'
} as const;
export type CredentialIssuanceStateResponseCredIssueStateEnum = typeof CredentialIssuanceStateResponseCredIssueStateEnum[keyof typeof CredentialIssuanceStateResponseCredIssueStateEnum];

/**
 * @export
 */
export const CredentialIssuanceStateResponseStateEnum = {
    Configuring: 'CONFIGURING',
    OobiResolving: 'OOBI_RESOLVING',
    Issuing: 'ISSUING',
    Admitting: 'ADMITTING',
    RequiresIssueRetry: 'REQUIRES_ISSUE_RETRY',
    RequiresAdmitRetry: 'REQUIRES_ADMIT_RETRY',
    Failed: 'FAILED',
    Success: 'SUCCESS'
} as const;
export type CredentialIssuanceStateResponseStateEnum = typeof CredentialIssuanceStateResponseStateEnum[keyof typeof CredentialIssuanceStateResponseStateEnum];


/**
 * Check if a given object implements the CredentialIssuanceStateResponse interface.
 */
export function instanceOfCredentialIssuanceStateResponse(value: object): boolean {
    return true;
}

export function CredentialIssuanceStateResponseFromJSON(json: any): CredentialIssuanceStateResponse {
    return CredentialIssuanceStateResponseFromJSONTyped(json, false);
}

export function CredentialIssuanceStateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CredentialIssuanceStateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'credIssueState': json['credIssueState'] == null ? undefined : json['credIssueState'],
        'state': json['state'] == null ? undefined : json['state'],
        'stateMachineId': json['stateMachineId'] == null ? undefined : json['stateMachineId'],
        'workflowInstanceId': json['workflowInstanceId'] == null ? undefined : json['workflowInstanceId'],
        'requesterId': json['requesterId'] == null ? undefined : json['requesterId'],
        'orgId': json['orgId'] == null ? undefined : json['orgId'],
        'schemaId': json['schemaId'] == null ? undefined : json['schemaId'],
        'recipient': json['recipient'] == null ? undefined : json['recipient'],
        'data': json['data'] == null ? undefined : json['data'],
        'issuerName': json['issuerName'] == null ? undefined : json['issuerName'],
        'oobi': json['oobi'] == null ? undefined : json['oobi'],
        'isRecipientAutomation': json['isRecipientAutomation'] == null ? undefined : json['isRecipientAutomation'],
        'missedParams': json['missedParams'] == null ? undefined : json['missedParams'],
    };
}

export function CredentialIssuanceStateResponseToJSON(value?: CredentialIssuanceStateResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'credIssueState': value['credIssueState'],
        'state': value['state'],
        'stateMachineId': value['stateMachineId'],
        'workflowInstanceId': value['workflowInstanceId'],
        'requesterId': value['requesterId'],
        'orgId': value['orgId'],
        'schemaId': value['schemaId'],
        'recipient': value['recipient'],
        'data': value['data'],
        'issuerName': value['issuerName'],
        'oobi': value['oobi'],
        'isRecipientAutomation': value['isRecipientAutomation'],
        'missedParams': value['missedParams'],
    };
}

